import { render, staticRenderFns } from "./SeriesPreview.vue?vue&type=template&id=0b2c5df2"
import script from "./SeriesPreview.vue?vue&type=script&lang=js"
export * from "./SeriesPreview.vue?vue&type=script&lang=js"
import style0 from "./SeriesPreview.vue?vue&type=style&index=0&id=0b2c5df2&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b2c5df2')) {
      api.createRecord('0b2c5df2', component.options)
    } else {
      api.reload('0b2c5df2', component.options)
    }
    module.hot.accept("./SeriesPreview.vue?vue&type=template&id=0b2c5df2", function () {
      api.rerender('0b2c5df2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SeriesPreview.vue"
export default component.exports